import {type CollectionSubType, CollectionSubTypes} from 'types';
import type {CollectionTypeDto} from 'services/series/types';
import {mapCollectionTypeDto, mapToCollectionTypeDto} from 'services/series';
import type {GetTokens} from './types';
import seriesQuery from './data/seriesQuery.json';
import {exceptionToPromiseReject} from './exceptionToPromiseReject';
import {httpElasticCount} from './http/search/httpElastic';

export const searchSeriesCount = (
  query: string,
  getTokens: GetTokens,
  abortSignal?: AbortSignal,
  mock?: boolean,
): Promise<Map<CollectionSubType, number>> => {
  const types: CollectionTypeDto[] = CollectionSubTypes.map(
    mapToCollectionTypeDto,
  );

  const queries = types.map(type =>
    JSON.stringify(seriesQuery, null)
      .replaceAll('${QUERY_PLACEHOLDER}', query.trim())
      .replaceAll('${SERIES_TYPE_PLACEHOLDER}', type),
  );

  return exceptionToPromiseReject(() =>
    httpElasticCount(
      getTokens,
      'ebs-series-alias',
      queries.map(q => JSON.parse(q)),
      abortSignal,
      mock,
    ).then(response => {
      const map = new Map<CollectionSubType, number>();
      for (let i = 0; i < response.responses.length; i++) {
        // The responses are in the same order as the types we sent.
        map.set(
          mapCollectionTypeDto(types[i]),
          response.responses[i].hits.total.value,
        );
      }

      return map;
    }),
  );
};
